export const ROLES_SET_LIST_DATA = 'ROLES_SET_LIST_DATA';
export const ROLES_SET_LIST_META = 'ROLES_SET_LIST_META';
export const ROLES_TITLE="Đối tượng quản lý";